<template>
  <div class="vz-order-payer-segregated">
    <div class="vz-order-payer-segregated-row">
      <div class="vz-order-payer-segregated-row-title" />
      <div class="vz-order-payer-segregated-row-column">
        Отправитель
      </div>
      <div class="vz-order-payer-segregated-row-column">
        Получатель
      </div>
      <div class="vz-order-payer-segregated-row-column">
        Третье лицо
      </div>
    </div>

    <vz-order-payer-segregated-item
      v-for="item of services"
      :item="item"
      @change="onChangeSegregatedPayer"
    />

    <div class="vz-order-payer-segregated-row">
      <div class="vz-order-payer-segregated-row-title" />
      <div class="vz-order-payer-segregated-row-column">
        {{ payerPrice('dispatch') }} {{ currencyMeasure }}
      </div>
      <div class="vz-order-payer-segregated-row-column">
        {{ payerPrice('destination') }} {{ currencyMeasure }}
      </div>
      <div class="vz-order-payer-segregated-row-column">
        {{ payerPrice('third') }} {{ currencyMeasure }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import VzOrderPayerSegregatedItem from '~/components/personal/order/payer/vz-order-payer-segregated-item.vue';
import useSegregatedPayer from '~/components/personal/order/payer/useSegregatedPayer';

const { payerPrice, currencyMeasure, onChangeSegregatedPayer, services } = useSegregatedPayer()
</script>
